import wasteManagementClient from './../services/wasteManagementClient';
import { wasteManagementUrls } from '../appConfig';
import { locale } from '../common/localization/localizationService';
import { IAuth, IUser } from '../models';
import { Auth0ContextInterface, User, LogoutOptions } from '@auth0/auth0-react';

export abstract class AuthService {
  public static async loginWithAuth0(user: IAuth): Promise<IUser> {
    try {
      const response = await wasteManagementClient.get(
        `${wasteManagementUrls.auth0Auth}?userName=${encodeURIComponent(user.username)}`,
      );

      response.data.token = user.password;

      const {
        token,
        customerId,
        contractorId,
        isAdmin,
        isLocalAdmin,
        impersonatedUser,
        auth0Roles,
        impersonableCustomerIds,
        impersonatedCustomerId,
        customername,
        isExternalContractor,
      } = response.data;
      if (!token) {
        throw new Error('Response is missing token parameter');
      }
      return {
        name: user.username,
        token,
        customerId,
        contractorId,
        isAdmin,
        isLocalAdmin,
        impersonatedUser,
        auth0Roles,
        impersonableCustomerIds,
        impersonatedCustomerId,
        customername,
        isExternalContractor,
      };
    } catch (error) {
      if (error.response.status === 401) {
        throw new Error(locale.login._usernamePasswordInvalid);
      } else {
        throw new Error('Unsuccessful attempt');
      }
    }
  }

  private static clearLocalStorage(): void {
    const keysToKeep = ['locale', 'calendarView', 'isDynamicOrder'];

    const elementsToKeep: Array<any> = [];
    keysToKeep.forEach((key) => {
      elementsToKeep.push({ key, value: localStorage.getItem(key) });
    });

    localStorage.clear();

    if (elementsToKeep.length) {
      elementsToKeep.forEach((vtk) => {
        localStorage.setItem(vtk.key, vtk.value);
      });
    }
  }

  public static logout(auth0: Auth0ContextInterface<User>): void {
    const logoutParams: LogoutOptions = {
      logoutParams: { returnTo: window.location.origin },
    };
    try {
      auth0.logout(logoutParams);
      this.clearLocalStorage();
      // localStorage.clear();
    } catch (error) {
      console.error(error);
    }
  }
}
